module.exports = __webpack_public_path__ + "assets/39b47501bf958fb08058d1da18956144.mp3";